import { FONT_TITLE, FONT_COLOUR_SCORE, COPY_WHITE } from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';
import * as Utils from 'utils/utils';

export default class LevelScoreDisplay extends Phaser.Group {
  constructor({ game, score = 0, labelCopy, scoreColour = FONT_COLOUR_SCORE, scoreFontSize = 75 }) {
    super(game);

    this.score = score;

    // // add main score
    this.label = createTextField(this.game, FONT_TITLE, 50, COPY_WHITE);
    this.label.text = labelCopy || '';
    this.add(this.label);

    // // add main score
    this.scoreDisplay = createTextField(this.game, FONT_TITLE, scoreFontSize, scoreColour);
    this.scoreDisplay.text = Utils.commaNumber(score);
    this.scoreDisplay.x = this.label.width + 20;
    this.add(this.scoreDisplay);

    this.label.y = this.scoreDisplay.height * 0.5 - this.label.height * 0.5;

    this.onUpdate = new Phaser.Signal();
    this.onAnimatedScoreComplete = new Phaser.Signal();
    this.onAnimatedScoreUpdated = new Phaser.Signal();
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get width() {
    return this.scoreDisplay.x + this.scoreDisplay.width;
  }
  get height() {
    return this.scoreDisplay.height;
  }

  /*
  ============================================================================================
    SETTER
  ============================================================================================
  */

  setScore(value) {
    this.score = value;
    this.setScoreDisplayText(this.score);
  }

  animateScore(from, targetScore, duration) {
    if (this.animatedTween) {
      this.animatedTween.stop();
    }

    this.animatedScoreTarget = from;
    this.animatedTween = this.game.add.tween(this).to({ animatedScoreTarget: targetScore }, duration || 1000, Phaser.Easing.Exponential.Out, true);
    this.animatedTween.onUpdateCallback(this.handleAnimatedScoreUpdate, this);
    this.animatedTween.onComplete.addOnce(this.handleAnimatedScoreComplete, this);
  }

  handleAnimatedScoreUpdate() {
    this.setScoreDisplayText(Math.ceil(this.animatedScoreTarget));
    this.onAnimatedScoreUpdated.dispatch();
  }

  handleAnimatedScoreComplete() {
    this.setScoreDisplayText(Math.ceil(this.animatedScoreTarget));
    this.onAnimatedScoreComplete.dispatch();
  }

  setScoreDisplayText(value) {
    this.scoreDisplay.text = Utils.commaNumber(value);
    // this.scoreTargetDisplay.x = this.scoreDisplay.x + this.scoreDisplay.width + 10;
  }

  /*
  ============================================================================================
    TOODLES
  ============================================================================================
  */

  destroy() {
    // destroy stuff - it's therapudic
    this.scoreDisplay.destroy(true);
    // nullify it - GC flag :)
    this.scoreDisplay = null;
    // super!!!!!
    super.destroy(true);
  }
}
